// LIBRARIES
import { Button, Typography } from "@mui/material";
import styled, { css } from "styled-components";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const SideMenuContainer = styled.div`
  width: 104px;
  height: 100vh;
  display: flex;
  font-size: 20px;
  flex-direction: column;
  background: #F5F5F5;
  opacity: 1;
  border-top-right-radius: 25px 25px;
  border-bottom-right-radius: 25px 25px;
  margin-left: 5px
  z-index: 1;
  padding-top: 100px;
`;

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-direction: center;
  align-items: center;
  @media screen and (max-height: 920px) {
    margin-bottom: 30px;
  }
  @media screen and (min-height: 901px) {
    margin-bottom: 80px;
  }
`;
export const SideMenuObject = styled(Button)(
  ({ selected }) => css`
    &.MuiButtonBase-root {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      height: 88px;
      width: 100%;
      background: ${selected ? COLORS.secondaryAppWhite : "transparent"}
    }
    &.MuiButtonBase-root:hover {
      background: ${COLORS.secondaryAppWhite};
    }
  `
);

export const LogoutButton = styled(Button)(
  ({ selected }) => css`
    &.MuiButtonBase-root {
      margin-top: auto;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      height: 88px;
      width: 100%;
      background: ${selected ? COLORS.secondaryAppWhite : "transparent"}
    }
    &.MuiButtonBase-root:hover {
      background: ${COLORS.secondaryAppWhite};
    }
  `
);

export const SideMenuText = styled.div`
  font-family: ${FONTS.newsharp};
  font-size: 40px;
  color: ${COLORS.primaryAppBlack};
  font-weight: bold;
`;

export const Image = styled.img`
margin-left: 10px
`;

export const LogoImage = styled.img`
  width: 100px;
  margin-top: 30px;
`;

export const Images = styled.img`
  margin-left: 17px;
  margin-right: 5px;
`;


export const MaintenanceToggleButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
`;

export const Subtitle = styled.text`
  font-size: 16px;
  font-weight: bold;
  color: ${COLORS.primaryAppBlack};
  font-family: ${FONTS.montserrat};
  margin-right: 20px;
`;

export const LabelContainer = styled(Typography)`
  font-family: ${FONTS.montserrat};
  color: ${COLORS.primaryAppBlack};
`;

export const SwitchContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const SwitchOption = styled.text`
  font-size: 16px;
  color: ${COLORS.primaryAppBlack};
  font-weight: bold;
`;

export const ImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`
